import { IChartLine } from '../useChartLines';
import { IDisplayedMeasure, ILineMetaNewExpression } from '../../interfaces';
import { QueryType } from '../../../../utils/apollo/graphqlSchema';
import { UnreachableCaseError } from 'ts-essentials';

interface IGetLineDisplayForSingleDateChart {
  line: IChartLine;
  linesMeta: ILineMetaNewExpression;
  displayedMeasures: IDisplayedMeasure[];
  isHistogram: boolean | undefined;
  queryType: QueryType.Funnel | QueryType.Expression;
}
// for single date chart (Single Day Bar/Funnel), we need to dynamically update the display name of the line.
// Detail rules: https://kubitai.atlassian.net/browse/KB-7065
export const getLineDisplayForSingleDateChart = ({
  line,
  linesMeta,
  displayedMeasures,
  isHistogram,
  queryType,
}: IGetLineDisplayForSingleDateChart) => {
  const lineMeta = linesMeta[line.name];
  // if it's histogram chart, we don't need to display measure name. therefore display slice name only.
  // slice name is string like [0, 10), [10, 20), etc.
  if (isHistogram) {
    return lineMeta.sliceName;
  } else {
    if (queryType === QueryType.Funnel) {
      return `${lineMeta.measureLabel}: ${lineMeta.measureName}`;
    } else if (queryType === QueryType.Expression) {
      const visibleMeasures = displayedMeasures.filter(
        (displayedMeasure) => displayedMeasure.isVisible,
      );
      if (visibleMeasures.length === 1) {
        return lineMeta.sliceName;
      } else {
        return lineMeta.measureLabel
          ? `${lineMeta.measureLabel}: ${lineMeta.measureName}`
          : lineMeta.measureName;
      }
    } else {
      throw new UnreachableCaseError(queryType);
    }
  }
};
